<template>
  <div class="progress-img-box">
    <img class="progress-img-box-img" :src="srcUrl" alt="">
  </div>
</template>

<script>
export default {
  props:['srcUrl']
}
</script>

<style lang="scss" scoped>
.progress-img-box{
  width: 100%;
  text-align: center;
  .progress-img-box-img{
    width: 90%;
    height: auto;
    margin: 0 auto;
  }
}
</style>